import React from 'react';
import { Input as FInput } from '@folksam/ui-next/components/molecules/Input';
import { useField } from 'react-final-form';
import FormField from './FormField';
import { combineValidators, required } from '../services/validators.service';
import { useTranslation } from 'react-i18next';

function Input({ label, validators = [], ...props }) {
    const { t } = useTranslation();
    const combinedValidations = combineValidators([required(t('empty_mandatory_error')), ...validators]);
    const { input, meta } = useField(props.name, { validate: combinedValidations });
    return (
        <FormField
            label={label}
            meta={meta}
            id={props.fieldId}
            component={FInput}
            inputProps={{
                ...props,
                id: props.fieldId,
                ...input,
                className: `sessioncamexclude`
            }}
        />
    );
}
export default Input;
